import './assets/main.css'

import { createRoot } from 'react-dom/client'
import Session from 'supertokens-web-js/recipe/session'
import App from './App'
import { initSuperTokens } from './config/supertokens'

// Initialize SuperTokens
try {
  initSuperTokens()
} catch (error) {
  console.error('Failed to initialize SuperTokens:', error)
}

// If the user logged in on a sibling subdomain (cookie-mode aurius-frontend),
// rotate that cookie session into a header-mode session so localStorage gets
// a bearer token. Otherwise getAccessToken() returns null and any API call to
// a different origin (rdp.*, etc.) ends up without an Authorization header.
// Fire-and-forget — refresh failures fall through to the normal login flow.
Session.attemptRefreshingSession().catch(() => {})

// StrictMode disabled in dev so the LiveKit hook doesn't double-mount
// and create two learner participants in the same room (which confuses
// the agent's audio subscription). Re-enable for production builds.
createRoot(document.getElementById('root')!).render(<App />)
